import { Form, Row, Col, Pagination } from 'react-bootstrap';
import React, { useEffect, useState, useMemo } from 'react';
import Select from 'react-select';
import Loading from '~/Components/Loading';
import { Timeline, TimelineItem } from 'vertical-timeline-component-for-react';
import { DATETIME_DEFAULT_FORMAT } from '~/constant';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';
import _orderBy from 'lodash/orderBy';
import { format } from '~/Utils/Helpers';
import SelectContratos from './select';
import { CanalAtendimento, getCanalNome } from '~/constant';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';
import AuthStorage from '~/Utils/AuthStorage';

const HistoricoProspecto = ({
  codigoProspecto,
  codigoFamilia,
  historicoFluxo,
  cpfProspecto,
  codigoConta,
  ge,
  empreendimentos,
}) => {
  const [opcao, setOpcao] = useState(null);
  const [contratos, setContratos] = useState([]);
  const [etapasVendas, setEtapasVendas] = useState([]);
  const [ocorrencias, setOcorrencias] = useState([]);
  const [historicoEdicoes, setHistoricoEdicoes] = useState([]);
  const [carregando, setCarregando] = useState(false);
  const [procurandoHistorico, setProcurandoHistorico] = useState(false);
  const [opcoesRadioButton, setOpcoesRadioButton] = useState([]);

  const [paginaAtual, setPaginaAtual] = useState(1);
  const [itensPorPagina] = useState(5);

  const [filtroGeral, setFiltroGeral] = useState({
    value: 'Todos',
    label: 'Todos',
  });

  const etapasProspecto = _orderBy(historicoFluxo, 'data', 'desc');

  const obterOpcoesSelect = () => {
    const combinacoes = new Map();
    ocorrencias.forEach(ocorrencia => {
      const chave = JSON.stringify({
        conta: ocorrencia.codigo_conta,
        ge: ocorrencia.codigo_grupo_empresa,
      });
      combinacoes.set(chave, {
        conta: ocorrencia.codigo_conta,
        ge: ocorrencia.codigo_grupo_empresa,
      });
    });

    const opcoes = [{ value: 'Todos', label: 'Todos' }];

    Array.from(combinacoes.keys())
      .sort()
      .forEach(chave => {
        const { conta, ge } = JSON.parse(chave);
        const empObj = empreendimentos.find(
          emp => emp.codigo_conta === conta && emp.codigo_grupo_empresa === ge
        );

        let nomeEmpreendimento = 'Empreendimento não encontrado';

        if (empObj && empObj.empreendimento) {
          nomeEmpreendimento =
            empObj.empreendimento.descricao_grupo_empresa ||
            'Empreendimento não encontrado';
        }

        opcoes.push({
          value: chave,
          label: `${nomeEmpreendimento} - ${ge}/${conta} `,
        });
      });

    return opcoes;
  };

  const filtrarOcorrencias = () => {
    let resultado = ocorrencias;

    if (filtroGeral && filtroGeral.value !== 'Todos') {
      const { conta, ge } = JSON.parse(filtroGeral.value);
      resultado = ocorrencias.filter(
        ocorrencia =>
          ocorrencia.codigo_conta === conta &&
          ocorrencia.codigo_grupo_empresa === ge
      );
    }

    const mesclado = [...resultado, ...historicoEdicoes];
    return _orderBy(mesclado, 'data', 'desc');
  };

  const buscarOcorrenciasProspecto = async () => {
    try {
      let response = await api.buscarOcorrenciasProspecto(cpfProspecto);
      if (response) {
        setOcorrencias(response);
      }
    } catch (error) {
      throw error;
    }
  };

  const buscarHistoricoEdicoesAtividades = async () => {
    try {
      let response = await api.buscarHistoricoEdicoesAtividades(
        codigoProspecto
      );
      if (response) {
        const edicoesFormatadas = response.map(edicao => ({
          data: edicao.data_atualizacao,
          titulo: `Modificou a anotação #${edicao.codigo_atividade}`,
          usuario: {
            codigo: edicao.codigo_usuario_alteracao,
            nome: edicao.usuario_alteracao,
          },
          texto: (() => {
            try {
              const descAnterior = JSON.parse(edicao.descricao_antiga || '{}');
              const descNova = JSON.parse(edicao.descricao_nova || '{}');
              return `De: ${descAnterior.descricao ||
                ''}\nPara: ${descNova.descricao || ''}`;
            } catch {
              return '';
            }
          })(),
          _tipo: 'edicao_atividade',
        }));
        setHistoricoEdicoes(edicoesFormatadas);
      }
    } catch (error) {
      console.error('Erro ao buscar histórico de edições:', error);
    }
  };

  const buscarContratosProspecto = async () => {
    try {
      let response = await api.obterContrato(codigoProspecto, codigoFamilia);
      if (response) {
        setContratos(response);
        if (contratos.length === 0) {
          setOpcao('Funil de Vendas');
        }
      }
    } catch (error) {
      throw error;
    }
  };

  const buscarHistoricoProspecto = async codigoPrevenda => {
    try {
      setProcurandoHistorico(true);
      let response = await api.obterHistoricoProspecto(codigoPrevenda);
      if (response) {
        setEtapasVendas(response);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setProcurandoHistorico(false);
    }
  };

  const carregarDados = async () => {
    try {
      setCarregando(true);
      await Promise.all([
        buscarOcorrenciasProspecto(),
        buscarContratosProspecto(),
        buscarHistoricoEdicoesAtividades(),
      ]);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setCarregando(false);
    }
  };

  const obterDadosParaPaginacao = () => {
    switch (opcao) {
      case 'Todos':
      case 'Ocorrências':
        return filtrarOcorrencias();
      case 'Funil de Vendas':
        return etapasProspecto;
      case 'Vendas':
        return etapasVendas;
      default:
        return [];
    }
  };

  const dadosPaginados = useMemo(() => {
    const dados = obterDadosParaPaginacao();
    const inicio = (paginaAtual - 1) * itensPorPagina;
    const fim = inicio + itensPorPagina;
    return dados.slice(inicio, fim);
  }, [
    opcao,
    filtroGeral,
    ocorrencias,
    historicoEdicoes,
    etapasProspecto,
    etapasVendas,
    paginaAtual,
    itensPorPagina,
  ]);

  const totalPaginas = useMemo(() => {
    const dados = obterDadosParaPaginacao();
    return Math.ceil(dados.length / itensPorPagina);
  }, [
    opcao,
    filtroGeral,
    ocorrencias,
    historicoEdicoes,
    etapasProspecto,
    etapasVendas,
    itensPorPagina,
  ]);

  const handleChangePage = numeroPagina => {
    setPaginaAtual(numeroPagina);
    const timelineElement = document.querySelector('.timeline-container');
    if (timelineElement) {
      timelineElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const renderPaginacao = () => {
    if (totalPaginas <= 1) return null;

    return (
      <>
        <div className="d-flex justify-content-center mt-4">
          <Pagination>
            <Pagination.First
              onClick={() => handleChangePage(1)}
              disabled={paginaAtual === 1}
            />
            <Pagination.Prev
              onClick={() => handleChangePage(paginaAtual - 1)}
              disabled={paginaAtual === 1}
            />

            {(() => {
              const delta = 2;
              const range = [];
              const rangeWithDots = [];

              for (
                let i = Math.max(2, paginaAtual - delta);
                i <= Math.min(totalPaginas - 1, paginaAtual + delta);
                i++
              ) {
                range.push(i);
              }

              if (paginaAtual - delta > 2) {
                rangeWithDots.push(1, '...');
              } else {
                rangeWithDots.push(1);
              }

              rangeWithDots.push(...range);

              if (paginaAtual + delta < totalPaginas - 1) {
                rangeWithDots.push('...', totalPaginas);
              } else if (totalPaginas > 1) {
                rangeWithDots.push(totalPaginas);
              }

              return rangeWithDots.map((i, index) => {
                if (i === '...') {
                  return <Pagination.Ellipsis key={`ellipsis-${index}`} />;
                }
                return (
                  <Pagination.Item
                    key={i}
                    active={i === paginaAtual}
                    onClick={() => handleChangePage(i)}
                  >
                    {i}
                  </Pagination.Item>
                );
              });
            })()}

            <Pagination.Next
              onClick={() => handleChangePage(paginaAtual + 1)}
              disabled={paginaAtual === totalPaginas}
            />
            <Pagination.Last
              onClick={() => handleChangePage(totalPaginas)}
              disabled={paginaAtual === totalPaginas}
            />
          </Pagination>
        </div>

        <div className="text-center mt-2">
          <small className="text-muted">
            Página {paginaAtual} de {totalPaginas} - Mostrando{' '}
            {dadosPaginados.length} de {obterDadosParaPaginacao().length} itens
          </small>
        </div>
      </>
    );
  };

  useEffect(() => {
    carregarDados();
  }, []);

  useEffect(() => {
    if (opcao === 'Todos') {
      setFiltroGeral({ value: 'Todos', label: 'Todos' });
    }
  }, [opcao]);

  useEffect(() => {
    setPaginaAtual(1);
  }, [opcao, filtroGeral]);

  return (
    <div>
      {!carregando && (
        <div>
          <Form className="mt-4">
            <Row className="text-center">
              {(!AuthStorage.isADM()
                ? ['Funil de Vendas', 'Vendas']
                : ['Todos', 'Ocorrências', 'Funil de Vendas', 'Vendas']
              ).map(valor => (
                <Col
                  key={valor}
                  md={AuthStorage.isADM() ? 3 : 6}
                  sm={AuthStorage.isADM() ? 3 : 6}
                >
                  <Form.Check
                    type="radio"
                    id={`radio-${valor.toLowerCase()}`}
                    label={valor}
                    name="customRadio"
                    value={valor}
                    checked={opcao === valor}
                    onChange={() => {}}
                    onClick={() => setOpcao(valor)}
                  />
                </Col>
              ))}
            </Row>
          </Form>
          {opcao === 'Ocorrências' &&
            !procurandoHistorico &&
            AuthStorage.isADM() && (
              <div className="mt-3 mb-3">
                <Row className="justify-content-center">
                  <Col md={6}>
                    <Form.Group className="mt-2">
                      <Select
                        value={filtroGeral}
                        options={obterOpcoesSelect()}
                        styles={customStyles}
                        components={{ DropdownIndicator }}
                        placeholder="Selecione uma opção"
                        isSearchable={true}
                        onChange={selectedOption => {
                          setFiltroGeral(selectedOption);
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            )}
          {opcao === 'Todos' && !procurandoHistorico && AuthStorage.isADM() && (
            <div className="text-center timeline-container">
              <Timeline lineColor={'#ddd'} animate={true}>
                {dadosPaginados.map((ocorrencia, index) => (
                  <TimelineItem
                    key={`${paginaAtual}-${index}`}
                    dateText={format.date(
                      ocorrencia.data,
                      DATETIME_DEFAULT_FORMAT
                    )}
                    dateInnerStyle={{
                      background:
                        ocorrencia._tipo === 'edicao_atividade'
                          ? '#ffc107'
                          : '#58d0ff',
                    }}
                    style={{
                      color:
                        ocorrencia._tipo === 'edicao_atividade'
                          ? '#ffc107'
                          : '#58d0ff',
                    }}
                  >
                    <div>
                      <div className="d-flex justify-content-between">
                        <h5 className="font-weight-bold">
                          {ocorrencia.titulo}
                        </h5>
                        {ocorrencia._tipo !== 'edicao_atividade' && (
                          <h6 className="font-weight-bold">
                            {getCanalNome(ocorrencia.canal_db)}
                          </h6>
                        )}
                      </div>
                      <span className="d-block">
                        <strong>Usuário: </strong> {ocorrencia.usuario.codigo} -{' '}
                        {ocorrencia.usuario.nome}
                      </span>
                      {ocorrencia._tipo !== 'edicao_atividade' && (
                        <div className="d-flex justify-content-between">
                          <span className="d-block">
                            <strong>Conta: </strong> {ocorrencia.codigo_conta}
                          </span>
                          <span className="d-block">
                            <strong>GE: </strong>{' '}
                            {ocorrencia.codigo_grupo_empresa}
                          </span>
                        </div>
                      )}
                      <pre className="text-area-content bordered">
                        {ocorrencia.texto}
                      </pre>
                    </div>
                  </TimelineItem>
                ))}
                {dadosPaginados.length === 0 && (
                  <TimelineItem
                    key={'nenhuma-ocorrencia'}
                    dateText={format.date(new Date(), DATETIME_DEFAULT_FORMAT)}
                    dateInnerStyle={{
                      background: '#58d0ff',
                    }}
                    style={{
                      color: '#58d0ff',
                    }}
                  >
                    <h5 className="font-weight-bold">
                      Nenhuma ocorrência encontrada para o filtro selecionado.
                    </h5>
                  </TimelineItem>
                )}
              </Timeline>
              {renderPaginacao()}
            </div>
          )}
          {opcao === 'Ocorrências' &&
            !procurandoHistorico &&
            AuthStorage.isADM() && (
              <div className="text-center timeline-container">
                <Timeline lineColor={'#ddd'} animate={true}>
                  {dadosPaginados.map((ocorrencia, index) => (
                    <TimelineItem
                      key={`${paginaAtual}-${index}`}
                      dateText={format.date(
                        ocorrencia.data,
                        DATETIME_DEFAULT_FORMAT
                      )}
                      dateInnerStyle={{
                        background:
                          ocorrencia._tipo === 'edicao_atividade'
                            ? '#ffc107'
                            : '#58d0ff',
                      }}
                      style={{
                        color:
                          ocorrencia._tipo === 'edicao_atividade'
                            ? '#ffc107'
                            : '#58d0ff',
                      }}
                    >
                      <div>
                        <div className="d-flex justify-content-between">
                          <h5 className="font-weight-bold">
                            {ocorrencia.titulo}
                          </h5>
                          {ocorrencia._tipo !== 'edicao_atividade' && (
                            <h6 className="font-weight-bold">
                              {getCanalNome(ocorrencia.canal_db)}
                            </h6>
                          )}
                        </div>
                        <span className="d-block">
                          <strong>Usuário: </strong> {ocorrencia.usuario.codigo}{' '}
                          - {ocorrencia.usuario.nome}
                        </span>
                        {ocorrencia._tipo !== 'edicao_atividade' && (
                          <div className="d-flex justify-content-between">
                            <span className="d-block">
                              <strong>Conta: </strong> {ocorrencia.codigo_conta}
                            </span>
                            <span className="d-block">
                              <strong>GE: </strong>{' '}
                              {ocorrencia.codigo_grupo_empresa}
                            </span>
                          </div>
                        )}
                        <pre className="text-area-content bordered">
                          {ocorrencia.texto}
                        </pre>
                      </div>
                    </TimelineItem>
                  ))}
                  {dadosPaginados.length === 0 && (
                    <TimelineItem
                      key={'nenhuma-ocorrencia'}
                      dateText={format.date(
                        new Date(),
                        DATETIME_DEFAULT_FORMAT
                      )}
                      dateInnerStyle={{
                        background: '#58d0ff',
                      }}
                      style={{
                        color: '#58d0ff',
                      }}
                    >
                      <h5 className="font-weight-bold">
                        Nenhuma ocorrência encontrada para o filtro selecionado.
                      </h5>
                    </TimelineItem>
                  )}
                </Timeline>
                {renderPaginacao()}
              </div>
            )}
          {opcao === 'Funil de Vendas' && !procurandoHistorico && (
            <div className="text-center timeline-container">
              <Timeline lineColor={'#ddd'} animate={true}>
                {dadosPaginados &&
                  dadosPaginados.map((etapa, index) => (
                    <TimelineItem
                      key={`${paginaAtual}-${index}`}
                      dateText={format.date(
                        etapa.data,
                        DATETIME_DEFAULT_FORMAT
                      )}
                      dateInnerStyle={{
                        background: '#58d0ff',
                      }}
                      style={{
                        color: '#58d0ff',
                      }}
                    >
                      <h5 className="font-weight-bold">
                        {etapa.status.descricao}
                      </h5>
                      <span className="d-block">
                        <strong>Usuario: </strong> {etapa.usuario.nome}
                      </span>
                      {etapa.corretor.nome && (
                        <span className="d-block">
                          <strong>Corretor: </strong> {etapa.corretor.nome}
                          {' - '}
                          <strong
                            style={{
                              color: `${etapa.imobiliaria.cor}`,
                            }}
                          >
                            {etapa.imobiliaria.nome}
                          </strong>
                        </span>
                      )}
                      <span className="d-block">
                        <strong>Empreendimento:</strong>{' '}
                        {etapa.empreendimento.descricao}
                      </span>
                      {etapa.evento_descarte && (
                        <>
                          <span className="d-block">
                            <strong>Motivo: </strong>
                            {etapa.evento_descarte.descricao_motivo}
                          </span>
                          <span className="d-block">
                            <strong>Justificativa: </strong>
                            {etapa.evento_descarte.justificativa}
                          </span>
                        </>
                      )}
                      {etapa.pre_venda && (
                        <>
                          <span className="d-block">
                            <strong>Pré-venda:</strong> {etapa.pre_venda.numero}{' '}
                            {' - '}
                            <strong>Quadra:</strong>{' '}
                            {etapa.pre_venda.imovel.quadra}
                            {' - '}
                            <strong>Lote:</strong> {etapa.pre_venda.imovel.lote}
                          </span>
                        </>
                      )}
                    </TimelineItem>
                  ))}
                {dadosPaginados.length === 0 && (
                  <TimelineItem
                    key={'nenhum-evento'}
                    dateText={format.date(new Date(), DATETIME_DEFAULT_FORMAT)}
                    dateInnerStyle={{
                      background: '#58d0ff',
                    }}
                    style={{
                      color: '#58d0ff',
                    }}
                  >
                    <h5 className="font-weight-bold">
                      Nenhum evento encontrado.
                    </h5>
                  </TimelineItem>
                )}
              </Timeline>
              {renderPaginacao()}
            </div>
          )}
          {opcao === 'Vendas' && (
            <Row className="d-flex justify-content-center text-center">
              <Col md={6}>
                <SelectContratos
                  contratos={contratos}
                  buscarHistoricoProspecto={buscarHistoricoProspecto}
                />
              </Col>
            </Row>
          )}
          {opcao === 'Vendas' && !procurandoHistorico && (
            <div className="text-center timeline-container">
              <Timeline lineColor={'#ddd'} animate={true}>
                {dadosPaginados &&
                  dadosPaginados.map((etapa, index) => (
                    <TimelineItem
                      key={`${paginaAtual}-${index}`}
                      dateText={format.date(
                        etapa.data_solicitacao_doc,
                        DATETIME_DEFAULT_FORMAT
                      )}
                      dateInnerStyle={{
                        background: '#58d0ff',
                      }}
                      style={{
                        color: '#58d0ff',
                      }}
                    >
                      <h5 className="font-weight-bold">
                        {etapa.descricao_tipo_doc}
                      </h5>
                      <span className="d-block">
                        <strong>Status: </strong>
                        {etapa.descricao_status_doc}
                      </span>

                      <span className="d-block">
                        <strong>Usuário Solicitação: </strong>{' '}
                        {etapa.codigo_usuario_solicitacao_doc} -{' '}
                        {etapa.usuario_solicitacao_doc}
                      </span>
                      {etapa.data_fim_doc && (
                        <span className="d-block">
                          <strong>Data finalização: </strong>
                          {format.date(
                            etapa.data_fim_doc,
                            DATETIME_DEFAULT_FORMAT
                          )}
                        </span>
                      )}
                    </TimelineItem>
                  ))}
                {dadosPaginados.length === 0 && (
                  <TimelineItem
                    key={'nenhum-evento'}
                    dateText={format.date(new Date(), DATETIME_DEFAULT_FORMAT)}
                    dateInnerStyle={{
                      background: '#58d0ff',
                    }}
                    style={{
                      color: '#58d0ff',
                    }}
                  >
                    <h5 className="font-weight-bold">
                      Nenhum evento encontrado.
                    </h5>
                  </TimelineItem>
                )}
              </Timeline>
              {renderPaginacao()}
            </div>
          )}
          {procurandoHistorico && (
            <div className="mt-4">
              <Loading label="Procurando histórico..." />
            </div>
          )}
        </div>
      )}
      {carregando && <Loading label="Carregando..." />}
    </div>
  );
};

export default HistoricoProspecto;
